import React from "react";

const LOGO_URL = "/assets/logo.png";

const NotFound = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      padding: "20px",
      textAlign: "center",
    }}
  >
    <img src={LOGO_URL} alt="WithYou Logo" style={{ width: 80, height: 80, marginBottom: 24 }} />
    <h1>Page Not Found</h1>
    <p>The page you are looking for does not exist.</p>
    <a
      href="https://www.withyou.net"
      style={{
        display: "inline-block",
        marginTop: "20px",
        padding: "12px 24px",
        background: "#1a73e8",
        color: "white",
        textDecoration: "none",
        borderRadius: "4px",
        fontWeight: "bold",
      }}
    >
      Visit WithYou
    </a>
  </div>
);

export default NotFound;
